module.exports = __webpack_public_path__ + "static/fallbackHero-a3e79f197e0c352677798c58e1f8b7eb.webp";